import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { formatPercentOneDecimal } from '@bingads-webui-campaign/recommendation-core';
import { getPopupSummaryStyle } from './style/popup-summary-style';

class PopupSummary extends React.PureComponent {
  static propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    overallOptimizationScoreBar: PropTypes.shape({
      Gained: PropTypes.number.isRequired,
      Dismissed: PropTypes.number.isRequired,
      Available: PropTypes.number.isRequired,
    }).isRequired,
    i18n: PropTypes.shape({
      getString: PropTypes.func,
    }).isRequired,
    scope: PropTypes.shape({
      values: PropTypes.shape({
        campaignId: PropTypes.string,
      }).isRequired,
    }).isRequired,
  };

  render() {
    const { Gained, Dismissed } = this.props.overallOptimizationScoreBar;
    const { classes, i18n, scope } = this.props;
    const scoreLabelText = {
      gained: !_.isUndefined(scope.values.campaignId) ? _TL_('Campaign optimization') : _TL_('Account optimization'),
      dismissed: _TL_('Dismissed recommendations'),
    };
    const scoreValue = { gained: Gained, dismissed: Dismissed };

    return (
      <div id="popup-summary-container" className={classes.popupSummaryContainer}>
        <div className={classes.scoreDetail}>
          {_.map(['gained', 'dismissed'], e => (
            scoreValue[e] > 0 &&
            <React.Fragment>
              <div className={classes.scoreLabel}>
                <div className={classes[`${e}ScoreLabelIcon`]} />
                <div htmlFor={e} className={classes.scoreLabelText}>
                  {i18n.getString(scoreLabelText[e])}
                </div>
              </div>
              <div className={classes.scoreValue}>
                {formatPercentOneDecimal(scoreValue[e], i18n)}
              </div>
            </React.Fragment>
          ))}
        </div>
        {Dismissed > 0 &&
          <div className={classes.scoreHint}>
            {i18n.getString(_TL_('Dismissed recommendations count towards to your account score'))}
          </div>
        }
      </div>
    );
  }
}

export const StyledPopupSummary =
  withDefaultStyles((PopupSummary), getPopupSummaryStyle);
